import React from 'react'
import styled from 'styled-components'
import { mediaMax } from 'frontend_core/dist/styles/media'
import Colors from 'frontend_core/dist/styles/colors'
import Icon from 'components/atoms/Icon'
import Button from 'components/atoms/Button'
import { Checkbox } from 'antd'
import {
  fontSize,
  spacing,
  zIndexes,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import { Input } from 'antd'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import Path from 'routes/path'

export const ErrorMessage = ({ children }) => {
  return (
    <ErrorMessageWrapper>
      <Icon className="fa fa-exclamation-circle" />
      {children}
    </ErrorMessageWrapper>
  )
}

export const NameInput = ({
  account,
  onChange,
  errorFamilyNameComponent,
  errorErrorGivenName,
}) => {
  return (
    <StyledHostFormSectionClearfix>
      <StyledHostFormNameWrap>
        <Input
          onChange={onChange}
          placeholder={i18n.t('page.shared.l_00059')}
          id="family_name"
          name="familyName"
          value={account.familyName}
        />
        {errorFamilyNameComponent}
      </StyledHostFormNameWrap>
      <StyledHostFormNameWrap>
        <Input
          onChange={onChange}
          placeholder={i18n.t('page.shared.l_00060')}
          name="givenName"
          value={account.givenName}
        />
        {errorErrorGivenName}
      </StyledHostFormNameWrap>
    </StyledHostFormSectionClearfix>
  )
}
export const EmailInput = ({ account, onChange, errorErrorEmail }) => {
  return (
    <StyledHostFormSection>
      <StyledHostFormWrap>
        <Input
          onChange={onChange}
          placeholder={i18n.t('page.shared.l_00046')}
          name="email"
          type="email"
          value={account.email}
        />
        {errorErrorEmail}
      </StyledHostFormWrap>
    </StyledHostFormSection>
  )
}
export const TelInput = ({ account, onChange, errorErrorTel }) => {
  return (
    <StyledHostFormSection>
      <StyledHostFormWrap>
        <Input
          onChange={onChange}
          lable={i18n.t('page.shared.l_00047')}
          placeholder={i18n.t('page.shared.l_00047')}
          value={account.tel}
          name="tel"
        />
        {errorErrorTel}
      </StyledHostFormWrap>
    </StyledHostFormSection>
  )
}
export const PasswordInput = ({ account, onChange, errorErrorPassword }) => {
  return (
    <StyledHostFormSection>
      <StyledHostFormWrap>
        <Input
          onChange={onChange}
          type="password"
          value={account.password}
          name="password"
          label={i18n.t('page.shared.l_00061')}
          placeholder={i18n.t('page.shared.l_00061')}
        />
        {errorErrorPassword}
      </StyledHostFormWrap>
    </StyledHostFormSection>
  )
}
export const PasswordConfirmationInput = ({
  account,
  onChange,
  errorPasswordConfirmation,
}) => {
  return (
    <StyledHostFormSection>
      <StyledHostFormWrap>
        <Input
          onChange={onChange}
          type="password"
          value={account.passwordConfirmation}
          name="passwordConfirmation"
          label={i18n.t('page.shared.l_00062')}
          placeholder={i18n.t('page.shared.l_00062')}
        />
        {errorPasswordConfirmation}
      </StyledHostFormWrap>
    </StyledHostFormSection>
  )
}
export const Terms = () => {
  return (
    <StyledHostFormTermsWrap>
      <StyledAText>
        本サービスのご利用には、
        <StyledATextLink href={wwwUrl('/about/terms')} target="_blank">スペースマーケット利用規約</StyledATextLink>
        ・
        <StyledATextLink href={wwwUrl('/about/terms_of_space_use')} target="_blank">ゲスト規約</StyledATextLink>
        ・
        <StyledATextLink href={wwwUrl('/owners/dashboard/about/terms_of_partner_for_new')} target="_blank">ホスト規約</StyledATextLink>
        ・
        <StyledATextLink href={wwwUrl('/about/privacy')} target="_blank">プライバシーポリシー</StyledATextLink>
        に同意していただく必要があります。
      </StyledAText>
    </StyledHostFormTermsWrap>
  )
}
export const AcceptTerm = ({
  account,
  onChange,
  errorErrorAcceptTermOfService,
}) => {
  return (
    <StyledHostFormSection>
      <StyledAHostFormCheck
        type="checkbox"
        value="規約に同意する"
      />
      <span>
        <StyledAHostFormCheckBox
          id="checkbox-1"
          onClick={onChange}
          name="acceptTermOfService"
          checked={account.acceptTermOfService}
        >
          規約に同意する
        </StyledAHostFormCheckBox>
      </span>
      {errorErrorAcceptTermOfService}
    </StyledHostFormSection>
  )
}
export const SubmitButtons = ({
  onSubmit,
  enteredAllInformation,
  canSubmit,
}) => {
  return (
    <StyledHostFormSection>
      <StyledHostFormButtonWrap>
        <Button
          large
          fontSizeSp="16"
          fontSizePc="16"
          colorType="green"
          onClick={onSubmit}
          buttonHeightPc="42"
          disabled={!enteredAllInformation || !canSubmit}
        >
          {i18n.t('page.hostEntry.registOwner')}
        </Button>
      </StyledHostFormButtonWrap>
    </StyledHostFormSection>
  )
}
export const OtherActions = ({ config }) => {
  return (
    <StyledHostFormSection>
      <StyledHostFormTextWrap>
        <StyledAText>
          {i18n.t('page.account.l_00037')}
          <StyledHostFormTextWrapATextBr />
          <StyledATextLink href={Path.login(config.URL)}>
            ログイン
          </StyledATextLink>
        </StyledAText>
      </StyledHostFormTextWrap>
      <StyledHostFormTextWrap>
        <StyledAText>
          <Icon className="fa fa-download a-faDownload" />
          資料ダウンロードは
          <StyledATextLink
            href="https://d1p70l9icfjben.cloudfront.net/docs/for-host.pdf?v=20230929"
            target="_blank"
          >
            こちら
          </StyledATextLink>
        </StyledAText>
      </StyledHostFormTextWrap>
    </StyledHostFormSection>
  )
}

export const HostAndGuestSignUpForm = ({
  nameInputComponent,
  emailInputComponent,
  telInputComponent,
  passwordInputComponent,
  passwordConfirmationInputComponent,
  termsComponent,
  acceptTermComponent,
  submitButtonsComponent,
  otherActionsComponent,
}) => {
  return (
    <div className="signup-box">
      <div className="row">
        <div className="col-xs-12">
          <h2 className="signup-box__title">
            {i18n.t('page.account.l_00013')}
          </h2>
          <div className="signup-box__wrapper-form">
            <div className="row signup-box__md-top">
              <p className="signup-box__note">
                以下メールアドレスでのご登録はお控えください。
              </p>
              <ul className="signup-box__note-list">
                <li>
                  <span className="icon-spm-close signup-box__list-icon" />
                  @docomo、@ezweb、@softbankなどのキャリアメール
                </li>
              </ul>
              {nameInputComponent}
              {emailInputComponent}
              {telInputComponent}
              {passwordInputComponent}
              {passwordConfirmationInputComponent}
              {termsComponent}
              {acceptTermComponent}
              {submitButtonsComponent}
              {otherActionsComponent}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const StyledHostFormSectionClearfix = styled.div`
  margin-top: ${spacing.medium}px;
  width: 100%;
  &::after {
    content: '';
    clear: both;
    display: block;
  }
`
const StyledHostFormSection = styled.div`
  margin-top: ${spacing.medium}px;
  width: 100%;
`
const StyledHostFormNameWrap = styled.div`
  width: calc(50% - 4px);
  margin-top: ${spacing.small_2}px;
  margin-right: ${spacing.small_2}px;
  float: left;
  &:last-child {
    margin-right: 0;
  }
  input {
    height: 40px;
  }
`
const StyledHostFormWrap = styled.div`
  margin-top: ${spacing.small_2}px;
  input {
    height: 40px;
  }
`
const StyledHostFormCheckWarp = styled.label`
  display: block;
  margin-top: ${spacing.medium}px;
`
const StyledHostFormTermsWrap = styled.div`
  margin-top: ${spacing.medium}px;
`
const StyledAHostFormCheck = styled.input`
  display: none;
`
const StyledAHostFormCheckBox = styled(Checkbox)`
  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: ${Colors.green};
    border-color: ${Colors.green};
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${Colors.green};
  }
  .ant-checkbox + span {
    font-size: ${fontSize.small_3}px;
  }
`
const StyledHostFormButtonWrap = styled.div`
  margin-top: ${spacing.medium}px;
  padding-bottom: ${spacing.medium}px;
  border-bottom: 1px solid ${Colors.grayD};

  & > div {
    display: block;
  }
`
const StyledHostFormTextWrap = styled.div`
  text-align: center;
  margin-top: ${spacing.medium}px;
`
const StyledHostFormTextWrapATextBr = styled.br`
  display: none;
  ${mediaMax.xs`
    display: inline;
  `};
`
const StyledAText = styled.p`
  font-size: ${fontSize.small_3}px;
  line-height: 1.6;
`
const StyledATextLink = styled.a`
  color: ${Colors.green};
`

const ErrorMessageWrapper = styled.p`
  color: ${Colors.red};
  font-size: ${fontSize.small_2}px;
  margin-top: 5px;
  margin-bottom: ${spacing.small_3}px;
  line-height: 1.35;
  i {
    margin-right: ${spacing.tiny}px;
  }
`
